<template>
  <NuxtLink
    :class="$style['highlight']"
    :no-prefetch="true"
    :to="{
      path: to
    }"
    @click="$emit('click')">
    <img
      :class="$style['highlight__image']"
      :src="`${config.public.cdnURL}pictures/navigation/highlights/${image}.webp`">
    <span v-if="title" :class="$style['highlight__title']">{{ title }}</span>
  </NuxtLink>
</template>
<script setup>
const config = useRuntimeConfig()
defineEmits(['click'])
defineProps({
  to: {
    type: String,
    default: ''
  },
  title: {
    type: String,
    default: ''
  },
  image: {
    type: String,
    default: ''
  }
})
</script>
<style lang="scss" module>
.highlight {
  border-radius: $border-radius;
  position: relative;
  display: block;
  max-height: fit-content;
  overflow: hidden;

  &__title {
    position: absolute;
    bottom: $spacing ;

    left: $spacing;
    padding: $spacing * 0.5 $spacing;
    background-color: $black;
    color: $white;
    width: fit-content;
    font-size: $font-size-m;
    font-family: $font-heading;
    font-weight: $font-weight-bold;
  }

  &__image {
    transition: transform $animate-time $transition-easing;
    background-color: $grey-lighter;
    object-fit: cover;
    display:block;

  }

  @media (max-width: $breakpoint-mobile) {
    height: auto;
    width: 50%;

    &__title {
      padding: 0 $spacing * 0.5;
      font-size: $font-size-s;
      font-weight: bold;
    }

    &__image {
      height: 100%;
      width:100%;
      object-fit:cover;
    }
  }

  &:hover{
    .highlight__image {
        transform: scale(1.05)
      }

  }
}
</style>
